import { useState, useEffect } from 'react'

/**
 * Hook to detect if a media query matches.
 * Uses matchMedia API for efficient, reactive media query detection.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.matchMedia(query).matches
    }
    return false
  })

  useEffect(() => {
    const mediaQuery = window.matchMedia(query)
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches)

    mediaQuery.addEventListener('change', handler)
    // Sync initial state in case it changed between render and effect
    setMatches(mediaQuery.matches)

    return () => mediaQuery.removeEventListener('change', handler)
  }, [query])

  return matches
}

/**
 * Convenience hook for mobile detection.
 * Returns true for viewports < 768px (below Tailwind's md breakpoint).
 */
export function useIsMobile(): boolean {
  return useMediaQuery('(max-width: 767px)')
}
